<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 日本入荷詳細画面（大連以外の工場）） -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="日本入荷基本情報" name="receJPBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 入荷No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.JP_RCV_NO')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="jpReceEditForm.jrbReceNo"
                      class="commonDialog"
                      maxLength="16"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 入荷日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.RECEIVE_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="jpReceEditForm.jrbReceDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :clearable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colCom">
                  <!-- 仕入先 -->
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.SUPPLIER_COMPANY')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbSupCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="cusChangeFlg"
                      @change="supCodeChange()"
                    >
                      <t-option
                        v-for="item in supCodeList"
                        :key="item.supCode"
                        :label="item.supCode + ':' + item.supAbbreviation"
                        :value="item.supCode"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbReceStatus"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in jrbReceStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <t-col :span="colArr.colCom">
                  <!-- 担当者 -->
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.CONNECTER_NAME')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbUserCode"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 支払状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.PAY_STATUS')"
                    class="marginBottom"
                    v-show="!localIsAdd"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbPayStatus"
                      placeholder=""
                      class="commonDialog"
                      :disabled="editDisableFlg"
                    >
                      <t-option
                        v-for="item in PayStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colCom * 2"> </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.REMARKS')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="jpReceEditForm.jrbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <!-- 注文一覧選択 -->
              <t-button
                round
                type="primary"
                class="button_long_search"
                @click="jpReceOrderSelectDialog"
                ref="jpOrderSelectBtn"
                :disabled="btnOrderSelectFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.JP_RECEIVE.ORDER_SELECT_BTN") }}
              </t-button></t-col
            >

            <!-- ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓ -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <!-- 配送単導入 -->
              <t-button
                round
                type="primary"
                class="button_long_search"
                @click="importDeliveryExcel"
                ref="importDeliveryExcelBtn"
                :disabled="!localIsAdd"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.JP_RECEIVE.IMPORT_DELIVERY_EXCEL") }}
              </t-button></t-col
            >
            <!-- ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑ -->

            <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
            <!-- 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する -->
            <!-- <t-col :span="12">&nbsp;</t-col> -->

            <t-col :span="1">&nbsp;</t-col>
            <t-col :span="5" class="col_common_left">
              <t-input
                ref="searchInput"
                v-model="searchWord"
                placeholder="キーワードを入力して検索する"
                @blur="handleSearchChange"
                maxLength="50"
                @clear="handleClear"
                @keyup.native.enter="handleSearchChange"
                class="input_icon_close"
                style="margin-top: 10px"
                clearable
              >
                <t-button
                  slot="append"
                  icon="el-icon-search"
                  class="button-default custom-button"
                  @click="handleSearchChange"
                ></t-button>
              </t-input>
            </t-col>
            <t-col :span="6">&nbsp;</t-col>
            <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 入荷チェックリスト出力 -->
              <!-- <t-button
                round
                type="primary"
                class="button_long_search"
                @click="OutPutClick"
                :disabled:="outPutClickFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.JP_RECEIVE.RECE_CHECK_OUTPUT") }}
              </t-button> -->
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
              <!-- 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する -->
              <!-- <t-table
                ref="jrbReceInfoTable"
                :data="jrbReceInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                :height="detailHeight"
                border
                fit
              >-->
              <t-table
                ref="jrbReceInfoTable"
                :data="filteredDetailTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                :height="detailHeight"
                border
                fit
              >
                <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->

                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template slot-scope="scope">
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row, column.prop)"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    />

                    <t-input
                      v-else-if="
                        column.prop === 'jrdRemarks' &&
                        scope.row.jrdUpdFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.jrdUpdFlg === '1'"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    /> -->

                    <t-input-number
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row, column.prop)"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    />

                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_備考機能の追加 -->
                    <!-- <t-input
                      v-else-if="
                        column.prop === 'jrdRemarks' &&
                        scope.row.jrdUpdFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.jrdUpdFlg === '1'"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <!-- 外観检查
                    <t-checkbox
                      v-else-if="column.prop === 'jrdAppearanceCheck'"
                      v-model="scope.row['jrdAppearanceCheckBool']"
                      @change="
                        handleCheckboxChange(
                          scope.row.index,
                          scope.column.index
                        )
                      "
                      :disabled="scope.row.jrdUpdFlg === '1'"
                    ></t-checkbox> -->

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <!-- 確定ボタン -->
            <t-col :span="24" align="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                :disabled="confirmBtnFlg"
                @click="jpReceConfirm"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowJpImportResultDialog,
  ShowJpReceOrderSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { showRemarksDialog, showRemarksUpdDialog } from "@/services/common";
import {
  addJpReceDetail,
  getJpReceDetailJP,
  getJpReceInitList,
  getOrderSelectedData,
  searchJpReceByDeliceryFile,
  updateJpReceDetail,
} from "@/services/jpReceive";
import {
  cmpBasicData,
  cmpDetailDataExceptRemarks,
  formatCurDateToString,
  formatRemarksShow,
  getAbleSupplierInfoList,
  getAbleUserInfoList,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  readZColumnFromXLSX,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NORMAL_PROD,
  NUM_ONE,
  NUM_ZERO,
  STR_EMPTY,
  STR_FIVE,
  STR_ONE,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      oldSupCode: "",
      activeNames: ["receJPBasic"],
      //注文一覧選択が使用可
      btnOrderSelectFlg: false,

      //確定ボタンの使用フラグ
      confirmBtnFlg: true,

      cusChangeFlg: false,

      //入荷OK数(保存済み)
      jrdReceOkQtyPreForm: [],

      // 支払状態
      PayStatusList: [],

      // 状態
      jrbReceStatusList: [],

      //入荷チェックリスト出力ボタンが使用可
      outPutClickFlg: true,

      //連絡担当
      connecterList: [],
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // editableColumns: ["jrdReceQty", "jrdReceNgQty", "jrdRemarks"],
      editableColumns: ["jrdReceQty", "jrdReceNgQty"],
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //異常区分
      prodExKbnList: [],
      //大連工場以外仕入先リスト
      supCodeList: [],

      jpReceEditForm: {
        jrbReceNo: "", //入荷No
        jrbReceDateOnly: "", // 入荷日(読み取り用)
        jrbReceDate: "", // 入荷日(保存用)
        jrbUserCode: "", // 連絡担当
        jrbReceStatus: "", // 状態
        jrbSupCode: "", // 仕入先
        jrbFactoryKbn: "", // 工場

        jrbPayStatus: "", // 支払状態
        jrbRemarks: "", // 備考

        jrbUpdateTime: "", // 更新時刻
        jrbUpdateUser: "", // 更新者
      },

      //入荷運送選択情報
      jrbReceInfoTable: [],

      maxheight: t("widgetSize.TRANSPORT_EDIT_DIALOG.HEIGHT_TABLE"),
      //テーブルの列
      columns: [
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.JP_RECEIVE.PRODUCT_NAME"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.JP_RECEIVE.PRODUCT_DRAW_NO"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.JP_RECEIVE.PRODUCT_UNIT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.JP_RECEIVE.PRODUCT_MATERIAL"),
        //   // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: 120,
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.JP_RECEIVE.PRODUCT_TREAT"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // 注文数
        {
          prop: "odProdQuantity",
          label: t("resource.JP_RECEIVE.PRODUCT_COUNT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 入荷済み数
        {
          prop: "aodProCompleteNum",
          label: t("resource.JP_RECEIVE.RECE_COMPLETE_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 入荷数量
        {
          prop: "jrdReceQty",
          label: t("resource.JP_RECEIVE.RECE_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 入荷OK数
        {
          prop: "jrdReceOkQty",
          label: t("resource.JP_RECEIVE.RECE_OK_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 入荷NG数
        {
          prop: "jrdReceNgQty",
          label: t("resource.JP_RECEIVE.RECE_NG_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 入荷残
        {
          prop: "jrdReceRemainQty",
          label: t("resource.JP_RECEIVE.RECE_REMAIN_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // // 外観検査
        // {
        //   prop: "jrdAppearanceCheck",
        //   label: t("resource.JP_RECEIVE.APPEARANCE_CHECK"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
        // 異常区分
        // {
        //   prop: "jrdProdExKbnShow",
        //   label: t("resource.JP_RECEIVE.ABNORMAL_DIFFERENCE"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },
        // 注文No
        {
          prop: "jrdOrderNoShow",
          label: t("resource.JP_RECEIVE.ORDER_NO"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 170,
          class: "cell_txt_left",
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // // 備考
        // {
        //   prop: "jrdRemarks",
        //   label: t("resource.JP_RECEIVE.REMARKS"),
        //   // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: 180,
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      localIsAdd: this.isAdd,

      editDisableFlg: true,

      //注文製品選択画面の検索条件
      selectedSearchConditionForm: [],

      //入荷明細情報(保存用)
      jpReceDetailInfo: [],

      showFlag: false,

      //基本情報のheight
      basicHeight: 49 + 45 + 45 + 65 + 45,
      // 明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // detailHeight:
      //   window.innerHeight * (1 - 0.1) -
      //   65 -
      //   (49 + 45 + 45 + 65 + 45) -
      //   DIALOG_LINE_HEIGHT -
      //   25,
      detailHeight:
        window.innerHeight * 0.99 -
        65 -
        (49 + 45 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT -
        25,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
      // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
      // 検索キー
      searchWord: "",
      // 一覧情報（画面表示）
      filteredDetailTable: [],
      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    basicData: {
      Type: Object,
      default: null,
    },
  },

  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
  // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
  watch: {
    filteredDetailTable: {
      handler(newVal) {
        this.jrbReceInfoTable = this.jrbReceInfoTable.map((originalItem) => {
          const matchedItem = newVal.find(
            (item) =>
              item.jrdOrderNo === originalItem.jrdOrderNo &&
              item.jrdDetailNo === originalItem.jrdDetailNo &&
              item.jrdProdExKbn === originalItem.jrdProdExKbn
          );
          return matchedItem ? { ...matchedItem } : originalItem;
        });
      },

      deep: true,
    },
  },
  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

  mounted() {
    this.init(this.basicData);
    // 列幅に自動調整
    // setColumnWidth(this.columns, this.jrbReceInfoTable);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する

    //クリア処理
    handleClear() {
      this.$refs.searchInput = "";
      this.searchWord = "";
      this.handleSearchChange();
    },
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

    //折り畳みパネルの処理
    handleCollapseChange(val) {
      this.handleResize(val);
    },

    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("receJPBasic") !== -1) {
        this.basicHeight = 49 + 45 + 45 + 65 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45 + 45 + 65 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   25;
        this.detailHeight =
          window.innerHeight * 0.99 -
          65 -
          (49 + 45 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT -
          25;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      } else {
        this.basicHeight = 49 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   20;
        this.detailHeight =
          window.innerHeight * 0.99 - 65 - (49 + 45) - DIALOG_LINE_HEIGHT - 20;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      ///基本情報のリスト取得（仕入先、担当者）
      getJpReceInitList()
        .then((res) => {
          //大連工場以外仕入先リスト
          this.supCodeList = res.jpOfiSuprCpyList;
          //日本入荷状態
          this.jrbReceStatusList = res.jrbStatusList;
          //連絡担当リストの取得
          this.connecterList = res.jrbUserList;
          //支払状態
          this.PayStatusList = res.jrbPayStatusList;
          //異常区分
          this.prodExKbnList = res.prodExKbnList;
          //初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
      // 列幅に自動調整
      // setColumnWidth(this.columns, this.jrbReceInfoTable);
    },

    //初期値の設定
    setInitValue(data) {
      //新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["receJPBasic"];
        this.handleCollapseChange(this.activeNames);
        // 入荷日:システム日
        this.jpReceEditForm.jrbReceDateOnly = new Date();
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_入荷状態の改善
        // 状態：新規
        // this.jpReceEditForm.jrbReceStatus = STR_ONE;
        this.jpReceEditForm.jrbReceStatus = STR_EMPTY;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // 支払状態
        this.jpReceEditForm.jrbPayStatus = STR_ONE;

        // this.jpReceEditForm.jrbSupCode = this.supCodeList[0]?.supCode;
        // 連絡担当
        this.jpReceEditForm.jrbUserCode = getUserInfo().UserId;
        this.showFlag = false;
        this.getAbleList();
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);

        this.jpReceEditForm = data;

        //日本入荷No.による日本入荷詳細情報の取得
        this.getJpReceDetailByReceNo();

        //入荷チェックリスト出力ボタンが使用可
        this.outPutClickFlg = false;

        //確定ボタンが使用可能に変更
        this.confirmBtnFlg = false;
      }
    },

    // 使用可能な担当者リスト、仕入先リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.jpReceEditForm.jrbUserCode
      );

      var supCode;
      if (!!this.jpReceEditForm.jrbSupCode) {
        supCode = this.jpReceEditForm.jrbSupCode.split(":")[0];
      }
      // 仕入先リスト
      this.supCodeList = getAbleSupplierInfoList(this.supCodeList, supCode);

      if (!this.jpReceEditForm.jrbSupCode) {
        this.jpReceEditForm.jrbSupCode = this.supCodeList[0]?.supCode;
      }
    },

    //日本入荷No.による日本入荷詳細情報の取得
    getJpReceDetailByReceNo() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      getJpReceDetailJP({ jrbReceNo: this.jpReceEditForm.jrbReceNo })
        .then((res) => {
          //********UserCode正しくない */
          this.jpReceEditForm = res.jpReceBasicInfo;
          this.jrbReceInfoTable = res.jpReceDetailInfoList;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (
            res.jpReceDetailInfoList != null &&
            res.jpReceDetailInfoList.length != 0
          ) {
            this.aodUpdateTime = res.jpReceDetailInfoList[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          this.getAbleList();

          this.dataProcess();
          this.oldSupCode = this.jpReceEditForm.jrbSupCode;

          for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
            const element = this.jrbReceInfoTable[index];
            if (element.jrdReceOkQty) {
              this.jrdReceOkQtyPreForm.push(element.jrdReceOkQty);
            }
          }
          // 列幅に自動調整
          // setColumnWidth(this.columns, this.jrbReceInfoTable);

          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
          // 発送予定一覧選択情報（画面表示）
          this.handleSearchChange();
          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データの処理
    dataProcess() {
      //仕入先支払データ存在する区分
      let payExistFlg = this.jrbReceInfoTable.some(
        (item) => item.jrdUpdFlg === STR_ONE
      );

      // 仕入先支払データ存在の場合、ボタンは使用できません
      if (payExistFlg) {
        this.btnOrderSelectFlg = true;
        this.cusChangeFlg = true;
      } else {
        this.btnOrderSelectFlg = false;
        this.cusChangeFlg = false;
      }

      let detailResult = [];

      this.jrbReceInfoTable.map((item, index) => {
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.jrdProdExKbnShow = ShowMergeExKbn(
          item.jrdProdExKbn,
          item.jrdProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // 入荷OK数: 入荷数 - 入荷NG数
        item.jrdReceOkQty = item.jrdReceQty - item.jrdReceNgQty;

        // 入荷残 =（注文数 - 注文クローズ数）-(入荷済み数 - クローズ済み数)- (入荷OK数 - クローズ数)

        item.jrdReceRemainQty =
          item.odProdQuantity - item.aodProCompleteNum - item.jrdReceOkQty;

        item.index = index;
        detailResult.push(item);

        return item;
      });

      // 読み込み回数 = 1
      if (!this.localIsAdd && this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.extractBasic(this.jpReceEditForm))
        );

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(detailResult));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // チェックボックスの選択
    handleCheckboxChange(row, column) {
      if (row.jrdUpdFlg === STR_ONE) {
        return;
      }
    },

    //「確定」ボタン
    jpReceConfirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
        const element = this.jrbReceInfoTable[index];

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        //入荷残<0
        // if (element.jrdReceRemainQty < 0 || element.jrdReceQty <= 0) {
        //   let message =
        //     "製品「" +
        //     element.aodProdName +
        //     "」の" +
        //     t("message.JP_RECEIVE.RECE_QTY_CHECK");
        //   Modal.showWarning("", message, {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   return;
        // }
        //入荷数<0
        if (element.jrdReceQty <= 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.RECE_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        //入荷OK数<0
        if (element.jrdReceQty - element.jrdReceNgQty < 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.NG_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (this.jrbReceInfoTable.length >= NUM_ONE) {
      //   if (this.localIsAdd) {
      //     //日本入荷台帳新規作成
      //     this.addJpReceDetailProc();
      //   } else {
      //     //日本入荷台帳編集保存
      //     this.updateJpReceDetailProc();
      //   }
      // } else {
      //   Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      // }

      //入荷残<0
      let rcvRemainQtyCheckFlg = this.jrbReceInfoTable.some(function (item) {
        return item.jrdReceRemainQty < 0;
      });
      if (rcvRemainQtyCheckFlg) {
        let message = t("message.CHECK_RECE_INFO.RCV_QTY_REMAIN_CONFIRM");

        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
          cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
          showCancelButton: true,
        })
          .then(() => {
            this.saveDataProc();
          })
          .finally(() => {
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
      } else {
        this.saveDataProc();
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 保存データ
    saveDataProc() {
      if (this.jrbReceInfoTable.length >= NUM_ONE) {
        if (this.localIsAdd) {
          //日本入荷台帳新規作成
          this.addJpReceDetailProc();
        } else {
          //日本入荷台帳編集保存
          this.updateJpReceDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // 日本入荷詳細情報の更新
    updateJpReceDetailProc() {
      this.dataAddUpdProc();

      updateJpReceDetail({
        jpReceBasicInfo: this.jpReceEditForm,
        jpReceDetailInfoList: this.jpReceDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          //検索処理を行う
          this.getJpReceDetailByReceNo();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    //運送明細情報の追加
    addJpReceDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();

      addJpReceDetail({
        jpReceBasicInfo: this.jpReceEditForm,
        jpReceDetailInfoList: this.jpReceDetailInfo,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.localIsAdd = false;
          //入荷チェックリスト出力ボタンが使用可
          this.outPutClickFlg = false;
          this.jpReceEditForm.jrbReceNo = res;
          //検索処理を行う
          this.getJpReceDetailByReceNo();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        });
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      // 入荷日
      this.jpReceEditForm.jrbReceDate = formatCurDateToString(
        this.jpReceEditForm.jrbReceDateOnly
      );

      //仕入先
      if (
        !!this.jpReceEditForm.jrbSupCode &&
        this.jpReceEditForm.jrbSupCode != STR_EMPTY
      ) {
        this.jpReceEditForm.jrbFactoryKbn = this.supCodeList.find(
          (it) => it.supCode === this.jpReceEditForm.jrbSupCode
        )?.supFactoryKbn;
      }
      // 更新者
      this.jpReceEditForm.jrbUpdateUser = getUserInfo().UserId;

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_入荷状態の改善
      if (
        this.jpReceEditForm.jrbReceStatus === undefined ||
        this.jpReceEditForm.jrbReceStatus === null ||
        this.jpReceEditForm.jrbReceStatus === STR_EMPTY ||
        !this.jpReceEditForm.jrbReceStatus
      ) {
        this.jpReceEditForm.jrbReceStatus = this.jrbReceStatusList[0]?.value;
      }
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      this.jpReceDetailInfo = this.jrbReceInfoTable;
      for (let index = 0; index < this.jpReceDetailInfo.length; index++) {
        const element = this.jpReceDetailInfo[index];
        this.jpReceDetailInfo[index].jrdReceNo = this.jpReceEditForm.jrbReceNo; // 入荷No
        this.jpReceDetailInfo[index].jrdReceDetailNo = index + 1; // 入荷明細No
        // this.jpReceDetailInfo[index].jrdAppearanceCheck =
        // element.jrdAppearanceCheckBool ? 1 : 0; // 外観検査
        if (!this.jpReceDetailInfo[index].jrdPayStatus && this.localIsAdd) {
          this.jpReceDetailInfo[index].jrdPayStatus = STR_ONE;
        }
      }
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jrbReceInfoTable);
    },

    // 注文製品選択画面画面を表示
    jpReceOrderSelectDialog() {
      // フォーカス削除
      this.$refs.jpOrderSelectBtn.$el.blur();

      if (
        !!!this.jpReceEditForm.jrbSupCode ||
        this.jpReceEditForm.jrbSupCode == STR_EMPTY
      ) {
        Modal.showWarning("", t("message.JP_RECEIVE.NO_NG_CUS_CODE"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }

      ShowJpReceOrderSelectDialog(
        {
          supCode: this.jpReceEditForm.jrbSupCode,
          tableData: this.jrbReceInfoTable,
          selectedSearchForm: this.selectedSearchConditionForm,
          jpReceNo: this.jpReceEditForm.jrbReceNo,
        },
        t("resource.JP_RECEIVE.ORDER_PROD_SELECT_DIALOG"),

        (target) => {
          if (!!target) {
            this.selectedSearchConditionForm = target.find(
              (item) => item.key === "searchConditionForm"
            ).value;

            getOrderSelectedData({
              jpReceDetailInfoList: target.find(
                (item) => item.key === "selectedProcForm"
              ).value,
              jrbReceNo: this.jpReceEditForm.jrbReceNo,
            })
              .then((res) => {
                let jrbReceInfoTable = this.jrbReceInfoTable;
                let jrbReceTableSelect = res.jpReceDetailInfoList;

                jrbReceTableSelect.forEach((item) => {
                  let existingProductIndex = jrbReceInfoTable.findIndex(
                    (p) =>
                      p.jrdOrderNo == item.jrdOrderNo &&
                      p.jrdDetailNo == item.jrdDetailNo &&
                      p.jrdProdExKbn == item.jrdProdExKbn
                  );

                  if (existingProductIndex == -1) {
                    item.jrdReceQty =
                      item.odProdQuantity - item.aodProCompleteNum;
                    item.jrdReceNgQty = NUM_ZERO;

                    this.jrbReceInfoTable.push(item);
                  }
                });

                this.jrbReceInfoTable = this.jrbReceInfoTable.filter((p) =>
                  jrbReceTableSelect.some(
                    (t) =>
                      p.jrdOrderNo == t.jrdOrderNo &&
                      p.jrdDetailNo == t.jrdDetailNo &&
                      p.jrdProdExKbn == t.jrdProdExKbn
                  )
                );
                this.dataProcess();

                // setColumnWidth(this.columns, this.jrbReceInfoTable);

                //確定ボタンが使用可能に変更
                this.confirmBtnFlg = false;

                // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
                // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
                // 一覧情報（画面表示）
                this.handleSearchChange();
                // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );
    },

    // 「運送製品リスト出力」ボタン
    OutPutClick() {
      this.$message("「運送製品リスト出力」ボタン");
    },

    //セルデータの編集
    editCellData(row, column) {
      //仕入先支払の日本入荷情報編集不可(クローズ数が編集可); クローズ数:正常製品入力可能、異常製品入力不可
      // 外観検査
      // if (column.prop === "jrdAppearanceCheck") {
      //   return false;
      // }

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // // 備考
      // if (column.prop === "jrdRemarks") {
      //   return false;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }

      if (row.jrdUpdFlg === STR_ONE) {
        return false;
      }
      return true;
    },

    //セルデータの保存
    changeCellData(row, prop) {
      row.jrdReceQty = this.checkNull(row.jrdReceQty);
      row.jrdReceNgQty = this.checkNull(row.jrdReceNgQty);
      // 入荷OK数: 入荷数 - 入荷NG数
      row.jrdReceOkQty = row.jrdReceQty - row.jrdReceNgQty;

      // 入荷残 =（注文数 - 注文クローズ数）-(入荷済み数 - クローズ済み数)- (入荷OK数 - クローズ数)
      row.jrdReceRemainQty =
        row.odProdQuantity - row.aodProCompleteNum - row.jrdReceOkQty;

      this.$set(this.jrbReceInfoTable, row.index, row);
      // setColumnWidth(this.columns, this.jrbReceInfoTable);
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      let columnIndex = this.editableColumns.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      if (index > this.jrbReceInfoTable.length - 1) {
        this.$refs[`input${0}`][columnIndex].focus();
      } else {
        this.$refs[`input${index}`][columnIndex].focus();
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      var columnEditable = [
        "jrdReceQty",
        "jrdReceNgQty",
        // "jrdAppearanceCheck",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // "jrdRemarks",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ];

      if (
        columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        // if (
        //   column.property == "jrdAppearanceCheck" &&
        //   row.jrdUpdFlg !== STR_ONE
        // ) {
        //   return "bg-cell-editable";
        // }

        if (this.localIsAdd) {
          return "bg-cell-editable";
        }

        if (row.jrdUpdFlg !== STR_ONE) {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
    },

    supCodeChange() {
      if (this.oldSupCode !== this.jpReceEditForm.jrbSupCode) {
        this.jrbReceInfoTable = [];
        this.oldSupCode = this.jpReceEditForm.jrbSupCode;
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (!!row.jrdProdExKbnShow && row.jrdProdExKbnShow != STR_EMPTY) {
      //   if (row.jrdProdExKbnShow === PROD_EX_SEND) {
      //     return "textColor";
      //   }
      // }
      if (row.jrdProdExKbnShow !== NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },
    checkNull(val) {
      if (!!!val || val === "" || typeof val === "undefined") {
        val = 0;
      }
      return val;
    },

    extractBasic(data) {
      return {
        jrbReceDateOnly: data.jrbReceDateOnly,
        jrbReceStatus: data.jrbReceStatus,
        jrbUserCode: data.jrbUserCode,
        jrbRemarks: data.jrbRemarks,
      };
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.jrbReceInfoTable.length > 0;
      } else {
        const extractedBasic = this.extractBasic(this.jpReceEditForm);
        const extractedDetails = this.jrbReceInfoTable;
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, extractedBasic) ||
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          //     !cmpDetailData( this.cmpDetailResult, extractedDetails);
          !cmpDetailDataExceptRemarks(
            this.cmpDetailResult,
            extractedDetails,
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // ["aodProdRemarksSum", "aodProdRemarks"]

            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
            // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
            //["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime"]
            ["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime", "index"]
            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          );
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.jrdQuoteNo,
        row.jrdProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })

        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            //　比較用明細情報の備考を変更する
            if (this.cmpDetailResult.length > 0) {
              this.cmpDetailResult.forEach((item) => {
                // 手配NO.と手配明細NO.一致の場合、備考を変更する
                if (
                  item.jrdOrderNo === row.jrdOrderNo &&
                  item.jrdDetailNo === row.jrdDetailNo
                ) {
                  item.aodProdRemarksSum = remarks;
                }
              });
            }
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.jrbReceInfoTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      showRemarksDialog(
        this,
        row.jrdQuoteNo,
        row.jrdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // this.aodUpdateTime
        row.aodUpdateTime
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正
            // this.aodUpdateTime = res.aodUpdateTime;

            row.aodUpdateTime = res.aodUpdateTime;
            this.jrbReceInfoTable
              .filter((item) => item.jrdQuoteNo === row.jrdQuoteNo)
              .forEach((item) => {
                item.aodUpdateTime = row.aodUpdateTime;
              });
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
            this.$set(this.jrbReceInfoTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
    importDeliveryExcel() {
      // フォーカス削除
      this.$refs.importDeliveryExcelBtn.$el.blur();

      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx";

      input.addEventListener("change", (e) => {
        const file = e.target.files[0];

        if (!file || !file.name.endsWith(".xlsx")) {
          this.showWaringMessage("xlsx 形式のファイルを選択してください");
          return;
        }

        let maxSize = 5 * 1024 * 1024;

        if (file.size > maxSize) {
          this.showWaringMessage(
            "ファイルサイズが大きすぎます。5MB未満のファイルを選択してください"
          );
          return;
        }

        readZColumnFromXLSX(file).then((result) => {
          try {
            const { jsonDataWithHeader, zColumnValues } = result;

            this.loading = true;

            this.fileJsonData = [];

            if (
              jsonDataWithHeader.length <= 0 ||
              typeof jsonDataWithHeader[0][0] === "undefined" ||
              jsonDataWithHeader[1][0].indexOf("NO.") == -1 ||
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // 配送単の「得意先納期」列の追加
              // +jsonDataWithHeader[1][26] != "詳細NO" ||
              jsonDataWithHeader[1][27] != "詳細NO" ||
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
              zColumnValues.length <= 0
            ) {
              this.showWaringMessage(
                "選択したファイルのフォーマットが間違った、確認してください"
              );
              return;
            }

            for (let i = 2; i < jsonDataWithHeader.length; i++) {
              if (
                !(
                  !isNaN(jsonDataWithHeader[i][0]) &&
                  jsonDataWithHeader[i][1] != ""
                )
              ) {
                break;
              }

              let hiddenData = JSON.parse(jsonDataWithHeader[i][25]);
              let misumiKbn = hiddenData.MisumiKbn;
              let supFacKbn = hiddenData.SupFacKbn;

              // 大連工場、またはミスミ大連の場合、取り込み不可
              if (
                supFacKbn == STR_ONE ||
                (supFacKbn != STR_ONE && misumiKbn == STR_FIVE)
              ) {
                this.showWaringMessage(
                  "選択したファイルの仕入先が間違った、確認してください"
                );
                return;
              }

              let lineData = {
                indexNo: jsonDataWithHeader[i][0],
                jrdOrderNoShow: jsonDataWithHeader[i][1],
                odDueDate: jsonDataWithHeader[i][2], // 仕入先納期列
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // aodProdName: jsonDataWithHeader[i][3],
                // aodProdDrawNo: jsonDataWithHeader[i][4],
                // prodExKbn: jsonDataWithHeader[i][5],
                // jrdReceQty: jsonDataWithHeader[i][6],
                // jrdReceNgQty: jsonDataWithHeader[i][7],
                // jrdReceOkQty:
                //   jsonDataWithHeader[i][6] - jsonDataWithHeader[i][7],
                // aodProdRemarksSum: jsonDataWithHeader[i][9],

                aodProdName: jsonDataWithHeader[i][4],
                aodProdDrawNo: jsonDataWithHeader[i][5],
                prodExKbn: jsonDataWithHeader[i][6],
                jrdReceQty: jsonDataWithHeader[i][7],
                jrdReceNgQty: jsonDataWithHeader[i][8],
                jrdReceOkQty:
                  jsonDataWithHeader[i][7] - jsonDataWithHeader[i][8],
                aodProdRemarksSum: jsonDataWithHeader[i][10],
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                odOrderNo: hiddenData.OrderNo,
                odOrderDetailNo: hiddenData.OdOrderDetailNo,
              };

              this.fileJsonData.push(lineData);
            }

            if (this.fileJsonData.length == 0) {
              this.showWaringMessage(
                "選択したファイルのフォーマットが間違った、確認してください"
              );
              return;
            }

            searchJpReceByDeliceryFile(this.fileJsonData)
              .then((res) => {
                if (res.Result) {
                  this.jrbReceInfoTable = res.ReceDetailInfos;

                  this.jpReceEditForm.jrbSupCode = res.SupCode;

                  // データの読み込
                  this.dataProcess();

                  // 確定ボタンFlag
                  this.confirmBtnFlg = false;
                } else {
                  ShowJpImportResultDialog(
                    {
                      jpReceByDeliveryDtos: res.jpReceByDeliveryDtos,
                    },
                    "配送単導入詳細情報",
                    (target) => {
                      if (!!target) {
                      }
                    }
                  );
                }
                // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
                // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
                // 一覧情報（画面表示）
                this.handleSearchChange();
                // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  this.showWaringMessage(
                    "選択したファイルのフォーマットが間違った、確認してください"
                  );
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } catch (error) {
            this.showWaringMessage(
              "選択したファイルのフォーマットが間違った、確認してください"
            );
          }
        });
      });

      input.click();
    },

    showWaringMessage(message) {
      Modal.showWarning("", message, {
        confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        onClose: () => {
          this.loading = false;
        },
      }).then(() => {
        this.loading = false;
      });
    },
    // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する

    // 全て製品表示の変化を監視する
    handleSearchChange() {
      // 一覧情報（画面表示）
      this.filteredDetailTable = this.jrbReceInfoTable;

      this.searchWord = this.searchWord.trim();
      if (
        this.searchWord !== STR_EMPTY &&
        this.searchWord !== undefined &&
        this.searchWord !== null
      ) {
        this.filteredDetailTable = this.filteredDetailTable.filter((data) => {
          return (
            (data.jrdOrderNoShow &&
              data.jrdOrderNoShow.includes(this.searchWord)) || // 手配NO.
            (data.aodProdDrawNo && data.aodProdDrawNo.includes(this.searchWord)) // 図番
          );
        });
      }

      this.dataProcess();
    },
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
</style>
